import React, { useContext, useEffect, useState } from "react"
import { Helmet } from "react-helmet"

import { ClientOnly, Layout } from "../components/common"
import BusinessClaimForm from "../components/business/BusinessClaimForm"
import FirebaseProvider, { FirebaseContext } from "../components/idealline/Firebase"

const ClaimBusinessContent = ({ location }) => {
  const auth = useContext(FirebaseContext)
  const [track, setTrack] = useState(null)
  const [state, setState] = useState("loading")

  useEffect(() => {
    let active = true
    const trackId = new URLSearchParams(location.search || "").get("track")
    if (!trackId) {
      setState("missing")
      return () => { active = false }
    }

    setState("loading")
    auth.app.firestore().collection("tracks").doc(trackId).get()
      .then(snapshot => {
        if (!active) return
        if (!snapshot.exists) {
          setState("missing")
          return
        }
        setTrack({ ...snapshot.data(), id: snapshot.id })
        setState("ready")
      })
      .catch(error => {
        console.error("Business claim track lookup failed", error)
        if (active) setState("error")
      })

    return () => { active = false }
  }, [auth.app, location.search])

  if (state === "loading") return <div className="py-20 text-center" aria-live="polite">Loading business details…</div>
  if (state === "missing") return <div className="rounded border border-gray-200 bg-gray-50 p-8" role="alert"><h1>Business not found</h1><p>Open a published track page and use its claim button.</p></div>
  if (state === "error") return <div className="rounded border border-red-200 bg-red-50 p-8" role="alert"><h1>Business could not be loaded</h1><p>Please try again from the track page.</p></div>

  return (
    <article className="mx-auto max-w-3xl py-12">
      <p className="mb-3 text-sm font-bold uppercase tracking-widest text-indigo-700">Business ownership</p>
      <h1 className="mb-4 text-4xl text-gray-900">Claim {track.name}</h1>
      <p className="mb-10 text-lg text-gray-600">Submit your relationship with this business for manual review. Claiming does not yet provide editing or listing-management access.</p>
      <BusinessClaimForm track={track} />
    </article>
  )
}

const ClaimBusinessPage = ({ location }) => (
  <>
    <Helmet>
      <title>Claim a Business | Open Racer</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <Layout>
      <ClientOnly>
        <FirebaseProvider>
          <ClaimBusinessContent location={location} />
        </FirebaseProvider>
      </ClientOnly>
    </Layout>
  </>
)

export default ClaimBusinessPage
